import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {
    title = 'spina.me';
}



// WEBPACK FOOTER //
// /home/ubuntu/spina-me/source/src/app/app.component.ts